import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import KioskLanguageToggle from '../components/KioskLanguageToggle';


export default function KioskLayout() {
  useEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains('dark');
    root.classList.remove('dark');
    root.classList.remove('kiosk-mode');
    root.classList.add('kiosk-mode');

    // Lock zoom on the kiosk only. Global index.html allows pinch-zoom for
    // a11y on public/admin screens; we swap in a stricter viewport while
    // mounted and restore the original on unmount.
    const viewport = document.querySelector('meta[name="viewport"]');
    const originalViewport = viewport?.getAttribute('content') ?? null;
    if (viewport) {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
      );
    }

    return () => {
      root.classList.remove('kiosk-mode');
      if (hadDark) root.classList.add('dark');
      if (viewport && originalViewport !== null) {
        viewport.setAttribute('content', originalViewport);
      }
    };
  }, []);

  return (
    <div className="kiosk kiosk-root">
      <div className="kiosk-viewport">
        {/* EN/FR switch for the WHOLE kiosk. Mounted at the layout level so it
            is reachable from every step of every kiosk route — see
            components/KioskLanguageToggle.js for the persistence contract.
            `kiosk-lang-toggle` opts it out of the `.kiosk-viewport > *`
            full-width stretch and pins it to the frame's top-right corner
            (see index.css). */}
        <KioskLanguageToggle className="kiosk-lang-toggle" />
        <Outlet />
      </div>
    </div>
  );
}
